import HTTP from '@/plugins/http';

const walletRecordApi = {
  page: '/walletRecord/list/page',
  export: '/walletRecord/export',
  total: '/walletRecord/amount/count'
};

function getPage({ data, params }) {
  return HTTP({ url: walletRecordApi.page, method: 'post', data, params });
}

function getTotal(data) {
  return HTTP({ url: walletRecordApi.total, method: 'post', data });
}
function doExport(params) {
  return HTTP.loading({
    url: walletRecordApi.export,
    method: 'post',
    data: params,
    responseType: 'blob'
  });
}

export default { getPage, getTotal, doExport };



// WEBPACK FOOTER //
// ./src/api/wallet.js